import ErrorBase from "./ErrorBase";

import type { JSX } from "react";
import { useRouteError } from "react-router-dom";

const UncaughtError = ({
    code = "Oops",
    title = "It's not you, it's us",
    description = "Something went wrong, please try again. The team has been notified. If the problem persists, please contact support",
}): JSX.Element => {
    return <ErrorBase code={code} title={title} description={description} />;
};

type ErrorProps = {
    status: number;
};

function isErrorProps(error: unknown): error is ErrorProps {
    return (
        typeof error === "object" &&
        error !== null &&
        Object.hasOwn(error, "status")
    );
}

export const UncaughtRouterError = () => {
    const error = useRouteError();

    if (isErrorProps(error) && error.status === 404) {
        return (
            <UncaughtError
                code={"404"}
                title={"Page not found"}
                description={""}
            />
        );
    }

    return <UncaughtError />;
};

export default UncaughtError;
